import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import { Box } from "@mui/material";

import { useMaterialUIController, setLayout } from "../../../context";
import { useAppCustomStyles } from "../../../assets/theme/custom/hooks";

function DashboardLayout({ children }: any) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();
  const layout = useAppCustomStyles().widgets.layoutContainers;

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname, dispatch]);

  return (
    <Box sx={layout.dashboardLayout({ miniSidenav })}>
      {children}
    </Box>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
